module.exports = __webpack_public_path__ + "img/refer.14a59618.svg";